module.exports = __webpack_public_path__ + "static/media/campus_ia.f53f01f1.jpg";